import { css } from '@emotion/core';
export default {
  name: "uk6cul",
  styles: "vertical-align:middle;"
};